<script>
import VLazyImage from 'v-lazy-image/v2';

export default {
  name: 'ImageProxy',
  components: {
    VLazyImage,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  computed: {
    proxyUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/proxy-image?src=${this.src}`;
    },
  },
};

</script>

<template>
  <a :href="proxyUrl" target="_blank">
    <v-lazy-image :src="proxyUrl" class="img" />
  </a>
</template>

<style scoped>
.img {
  max-width: 64px;
}
</style>
